// EyeOpenSvg.js
export const EyeOpenSvg = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5C7 5 3.3 8.8 1.9 11.5a1 1 0 000 .9C3.3 15.2 7 19 12 19s8.7-3.8 10.1-6.5a1 1 0 000-.9C20.7 8.8 17 5 12 5zm0 12c-4.5 0-7.9-3-9.1-5C4.1 10 7.5 7 12 7s7.9 3 9.1 5c-1.2 2-4.6 5-9.1 5zm0-9a4 4 0 100 8 4 4 0 000-8zm0 6a2 2 0 110-4 2 2 0 010 4z"
        fill="#FFF"
      />
    </svg>
  );
  